import React from "react";
import { Paper, Typography,  Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useShipSettings } from "../../Contexts/ShipSettingsContext";

const CargoTankStatus = () => {
  const { tanks } = useShipSettings();
  const theme = useTheme();

  const tankData = (tanks || []).map((tank) => {
    const max =
      Number(tank.maxVolumeM3) ||
      Number(tank.capacityM3) ||
      Number(tank.maxVolume) ||
      Number(tank.volume) ||
      0;
    const current =
      Number(tank.currentVolumeM3) ||
      Number(tank.obsVolume) ||
      Number(tank.gsvVolume) ||
      0;

    return {
      name: tank.name,
      productName: tank.productName || tank.lastCargo || "Configured tank",
      current,
      max,
      temp: tank.temperatureC || tank.temp || "",
      weightAir: tank.weightAir || "",
      weightVac: tank.weightVac || "",
      obsVolume: tank.obsVolume || "",
      gsvVolume: tank.gsvVolume || "",
      refDensity: tank.refDensity || tank.density || "",
      percent: max > 0 ? Math.round((current / max) * 100) : 0,
    };
  });

  return (
    <Paper
      sx={{ p: 2, boxShadow: 3, bgcolor: "background.paper" }}
      elevation={3}
    >
      <Typography variant="h6" gutterBottom>
        Cargo Tank Status
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Vessel tank layout from current ship master data.
      </Typography>

      {tankData.length === 0 && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          No cargo tanks are configured for the selected vessel yet.
        </Typography>
      )}

      <Grid container spacing={2}>
        {tankData.map((t) => (
          <Grid key={t.name} size={{ xs: 12, sm: 6, md: 2, lg: 3 }}>
            <Box
              sx={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 3,
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: 1,
                bgcolor: "background.default",
                minHeight: 120,
              }}
            >
              {/* Textinfo */}
              <Box sx={{ textAlign: "left", pr: 2, flexGrow: 1 }}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  color="text.primary"
                >
                  {t.name} - {t.productName}
                </Typography>
                <Typography
                  variant="body1"
                  fontWeight="medium"
                  color="text.primary"
                >
                  {t.current} m³
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Max {t.max} m³
                </Typography>

                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  Avg Temp: {t.temp}°C
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  Weight Air: {t.weightAir} t
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  Weight Vac: {t.weightVac} t
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  OBS Volume: {t.obsVolume} m³
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  GSV Volume: {t.gsvVolume} m³@15°C
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  color="text.secondary"
                >
                  Ref. Density: {t.refDensity} t/m³
                </Typography>
              </Box>

              {/* Vertikal stapel */}
              <Box
                sx={{
                  height: 120,
                  width: 32,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 4,
                  bgcolor: theme.palette.background.paper,
                  display: "flex",
                  alignItems: "flex-end",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: `${t.percent}%`,
                    backgroundColor:
                      t.percent > 90
                        ? theme.palette.error.main
                        : t.percent >= 50
                        ? theme.palette.warning.main
                        : theme.palette.success.main,
                    transition: "height 0.5s ease, background-color 0.3s ease",
                    borderBottomLeftRadius: 4,
                    borderBottomRightRadius: 4,
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    position: "absolute",
                    top: -18,
                    left: "50%",
                    transform: "translateX(-50%)",
                    fontWeight: 500,
                    color: "text.primary",
                  }}
                >
                  {t.percent}%
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default CargoTankStatus;
